var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5735 2H5.6735C3.4835 2 2.3335 3.15 2.3335 5.33V7.23C2.3335 9.41 3.4835 10.56 5.6635 10.56H7.5635C9.7435 10.56 10.8935 9.41 10.8935 7.23V5.33C10.9035 3.15 9.7535 2 7.5735 2Z",
    fill: "url(#paint0_linear_89_892)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0034 2H17.1034C14.9234 2 13.7734 3.15 13.7734 5.33V7.23C13.7734 9.41 14.9234 10.56 17.1034 10.56H19.0034C21.1834 10.56 22.3334 9.41 22.3334 7.23V5.33C22.3334 3.15 21.1834 2 19.0034 2Z",
    fill: "url(#paint1_linear_89_892)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0034 13.4301H17.1034C14.9234 13.4301 13.7734 14.5801 13.7734 16.7601V18.6601C13.7734 20.8401 14.9234 21.9901 17.1034 21.9901H19.0034C21.1834 21.9901 22.3334 20.8401 22.3334 18.6601V16.7601C22.3334 14.5801 21.1834 13.4301 19.0034 13.4301Z",
    fill: "url(#paint2_linear_89_892)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5735 13.4301H5.6735C3.4835 13.4301 2.3335 14.5801 2.3335 16.7601V18.6601C2.3335 20.8501 3.4835 22.0001 5.6635 22.0001H7.5635C9.7435 22.0001 10.8935 20.8501 10.8935 18.6701V16.7701C10.9035 14.5801 9.7535 13.4301 7.5735 13.4301Z",
    fill: "url(#paint3_linear_89_892)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_892",
    x1: 4.90847,
    y1: 3.52803,
    x2: 8.07316,
    y2: 9.37848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_892",
    x1: 16.3484,
    y1: 3.52803,
    x2: 19.5131,
    y2: 9.37846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_892",
    x1: 16.3484,
    y1: 14.9581,
    x2: 19.5131,
    y2: 20.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_89_892",
    x1: 4.90847,
    y1: 14.9599,
    x2: 8.07888,
    y2: 20.8141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryGradient);
export default __webpack_public_path__ + "static/media/category-gradient.fb612e07f976a0aaac8149bd5b218809.svg";
export { ForwardRef as ReactComponent };